import { render, staticRenderFns } from "./ScalapayResult.vue?vue&type=template&id=230f8260&"
import script from "./ScalapayResult.vue?vue&type=script&lang=js&"
export * from "./ScalapayResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports